import { gql } from 'graphql-tag';

// Mutation to start the members export job (uses annuals export worker with type: 'membership')
export const EXPORT_MEMBERS = gql`
  mutation GetAccountAnnualsReport($input: AccountMembersInput!) {
    getAccountAnnualsReport(input: $input) {
      jobId
      message
    }
  }
`;

// Subscription to track export status
export const MEMBERS_EXPORT_STATUS = gql`
  subscription AccountAnnualsExportStatus($jobId: String!) {
    accountAnnualsExportStatus(jobId: $jobId) {
      jobId
      status
      progress
      filename
      recordCount
      error
    }
  }
`;

// Query to get download URL when complete
export const GET_MEMBERS_EXPORT_DOWNLOAD_URL = gql`
  query GetAccountAnnualsExportDownloadUrl($jobId: String!) {
    getAccountAnnualsExportDownloadUrl(jobId: $jobId)
  }
`;
